export default {
  namespaced: true,
  vlm_configuration: {
    title: "Configuración de VLM",
    subtitle: "Prepara la política de análisis de video sin enviar contenido a proveedores externos.",
    list_subtitle: "Administra las configuraciones de análisis de video disponibles.",
    new_configuration: "Nueva configuración VLM",
    edit_configuration: "Editar configuración VLM",
    add_configuration: "Añadir configuración",
    back_to_list: "Regresar a la lista",
    name: "Nombre de la configuración",
    name_placeholder: "Ej. Seguridad de planta norte",
    empty_list: "Aún no hay configuraciones VLM.",
    delete_configuration: "Eliminar configuración",
    delete_confirmation: "¿Deseas eliminar la configuración \"{name}\"? Esta acción no se puede deshacer.",
    delete: "Eliminar",
    cancel: "Cancelar",
    cameras: "Cámaras",
    cameras_hint: "Selecciona las cámaras reales que usará la configuración.",
    prompt: "Instrucción de análisis",
    prompt_placeholder: "Describe qué debe identificar el modelo en el video.",
    presets: "Ejemplos rápidos",
    fallen_person: "Persona caída",
    fight: "Pelea entre personas",
    disorder: "Área de trabajo desordenada",
    model: "Modelo de IA",
    model_gemini_flash: "Gemini 2.5 Flash",
    model_gemini_pro: "Gemini 2.5 Pro",
    model_openai: "OpenAI GPT-5.6 Terra",
    model_gemini_description: "Procesamiento de video nativo para análisis multimodal.",
    model_openai_description: "Análisis de frames; no procesa streams de video nativos.",
    analysis_policy: "Política de análisis",
    enabled: "Activar configuración VLM",
    sampling_interval: "Intervalo de muestreo",
    confidence_threshold: "Umbral de confianza",
    seconds: "segundos",
    summary: "Resumen",
    selected_cameras: "Cámaras seleccionadas",
    service_status: "Estado del servicio",
    active: "Activo",
    inactive: "Inactivo",
    updated_at: "Última actualización",
    not_saved: "Sin guardar",
    save: "Guardar configuración",
    read_only: "No tienes permiso para actualizar esta configuración.",
    load_error: "No fue posible cargar la configuración VLM.",
    save_error: "No fue posible guardar la configuración VLM.",
    saved: "Configuración VLM guardada correctamente.",
    created: "Configuración VLM creada correctamente.",
    updated: "Configuración VLM actualizada correctamente.",
    deleted: "Configuración VLM eliminada correctamente.",
    delete_error: "No fue posible eliminar la configuración VLM.",
    preset_fallen: "Analiza el video e identifica si hay una persona caída. Reporta únicamente hallazgos con una marca de tiempo y nivel de confianza.",
    preset_fight: "Analiza el video e identifica posibles peleas o agresiones entre personas. Reporta únicamente hallazgos con una marca de tiempo y nivel de confianza.",
    preset_disorder: "Analiza el video e identifica áreas de trabajo desordenadas u obstrucciones relevantes. Reporta únicamente hallazgos con una marca de tiempo y nivel de confianza.",
  },
};
